import React from 'react';
import PropTypes from 'prop-types';

import { RankingCategoryTypes } from '../constants';

import styles from '../localizedRankings.scss';

const RankingCategories = ({
    onCategoryClick,
    selectedCategory,
    availableCategories = [],
    categoriesToShow = [],
    shouldShowAllCategories = false,
}) => {
    const allCategories = [
        {
            label: 'City',
            value: RankingCategoryTypes.CITY,
        },
        {
            label: 'State',
            value: RankingCategoryTypes.STATE,
        },
        {
            label: 'Country',
            value: RankingCategoryTypes.COUNTRY,
        },
        {
            label: 'World',
            value: RankingCategoryTypes.WORLD,
        },
    ];

    // Determine which categories to display
    const categories = shouldShowAllCategories
        ? allCategories.filter(cat => categoriesToShow.includes(cat.value))
        : allCategories.filter(cat => availableCategories.includes(cat.value));

    return (
        <div className={styles.categoryButtonContainer}>
            {categories.map((category) => {
                const isSelected = selectedCategory === category.value;

                return (
                    <button
                        type="button"
                        key={category.value}
                        onClick={() => onCategoryClick(category.value)}
                        className={isSelected ? styles.categoryButtonSelected : styles.categoryButton}
                    >
                        {category.label}
                    </button>
                );
            })}
        </div>
    );
};

RankingCategories.propTypes = {
    onCategoryClick: PropTypes.func.isRequired,
    selectedCategory: PropTypes.string.isRequired,
    availableCategories: PropTypes.arrayOf(PropTypes.string),
    categoriesToShow: PropTypes.arrayOf(PropTypes.string),
    shouldShowAllCategories: PropTypes.bool.isRequired,
};

RankingCategories.defaultProps = {
    availableCategories: [],
    categoriesToShow: [],
};

export default RankingCategories;
